import { Component, Input, OnInit, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { ProjetoRelatorioService } from '../../../services/projeto-relatorio.service';

@Component({
  selector: 'app-projeto-relatorio-2',
  templateUrl: './projeto-relatorio-2.component.html',
  styleUrls: ['./projeto-relatorio-2.component.scss']
})
export class ProjetoRelatorio2Component extends BaseListComponent<any> implements OnInit {
  @Input() report_1_param_1: number = 0;
  @Input() report_3_param_1: number = 0
  @Input() filter_question: number = 0;
  @Input() report_type: number = 1;
  @Input() filter_agency: number[] = [];

  listData:any;

  constructor(
    private projetoRelatorioService: ProjetoRelatorioService,
    private cdr: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit() {
    this.get();
  }

  sumTotals(items:any):any {
    let result = {};
    result['agency_count'] = items?.length ?? 0;
    result['cost_total'] = items?.reduce((sum, item) => sum + Number(item.cost_total), 0) ?? 0;
    result['cost_without_loan'] = items?.reduce((sum, item) => sum + Number(item.cost_without_loan), 0) ?? 0;
    result['cost_loan'] = items?.reduce((sum, item) => sum + Number(item.cost_loan), 0) ?? 0;
    return result;
  }
  
  onPrint(): void {
    // Aumentar timeout para garantir renderização completa antes de imprimir
    setTimeout(() => {
      window.print();
    }, 500);
  }
  
  get() {
    this.loading();
    let filter ={
      report_type: this.report_type,
      filter_agency: this.filter_agency,
      filter_question: this.filter_question
    };
    this.addSub(
      this.projetoRelatorioService.getData(this.report_type, filter).subscribe({
        next: (res) => {
          this.loaded();
          this.listData = res.items;
          this.cdr.detectChanges();
          setTimeout(() => {
            this.onPrint();
          }, 100);
        },
        error: (erro) => {
          this.msgError(erro?.message);
          this.loaded();
        },
      })
    );
  }

}
